import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imgSrc } from "../context/ContentContext";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`font-display text-xs font-bold uppercase tracking-[0.2em] text-[#8E8D8A] ${className}`}
  >
    {children}
  </p>
);

export const Ribbon = ({ children, className = "" }) => (
  <span
    className={`inline-block bg-cream px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-[#111111] sm:text-base ${className}`}
  >
    {children}
  </span>
);

export const ImageCard = ({
  to,
  image,
  label,
  testid,
  aspect = "aspect-[3/2]",
}) => {
  const inner = (
    <div className="relative">
      <div className={`relative overflow-hidden ${aspect}`}>
        <img
          src={imgSrc(image.src)}
          alt={image.alt}
          className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]"
          loading="lazy"
        />
      </div>
      <Ribbon className="absolute -bottom-4 left-4">{label}</Ribbon>
    </div>
  );
  return to ? (
    <Link to={to} data-testid={testid} className="group block pb-4">
      {inner}
    </Link>
  ) : (
    <div data-testid={testid} className="group pb-4">
      {inner}
    </div>
  );
};

export const ButtonPrimary = ({ to, children, testid, type, disabled }) => {
  const cls =
    "inline-block rounded-[4px] bg-cream px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-[#111111] transition-colors duration-200 hover:bg-cream-deep disabled:cursor-wait disabled:opacity-70";
  if (to) {
    return (
      <Link to={to} data-testid={testid} className={cls}>
        {children}
      </Link>
    );
  }
  return (
    <button type={type || "button"} data-testid={testid} className={cls} disabled={disabled}>
      {children}
    </button>
  );
};

export const ButtonGhost = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="inline-block rounded-[4px] border border-[#111111] px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-[#111111] transition-colors duration-200 hover:border-cream hover:bg-cream"
  >
    {children}
  </Link>
);
